import { render, staticRenderFns } from "./QrcodeBlock.vue?vue&type=template&id=ad800250&scoped=true"
import script from "./QrcodeBlock.vue?vue&type=script&lang=js"
export * from "./QrcodeBlock.vue?vue&type=script&lang=js"
import style0 from "./QrcodeBlock.vue?vue&type=style&index=0&id=ad800250&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad800250",
  null
  
)

export default component.exports